import React from 'react'

import { useTranslationRankmi } from 'helpers/translations.helper'

interface UploadCertificatesProps {
  className?: string
  onClick?(): void
}

const UploadCertificates: React.FC<UploadCertificatesProps> = ({
  className,
  onClick,
}) => {
  const tUpload = useTranslationRankmi({
    prefix: 'administration.externalCourses.list.uploadCertificates',
  })

  return (
    <>
      <div
        className={className}
        onClick={() => {
          onClick && onClick()
        }}
      >
        {tUpload('label')}
      </div>
    </>
  )
}

export default UploadCertificates
